import { TYPES } from './constants';
export const getActiveItems = (type, activeItem) => {
  const isOnlyOneActiveItem = type === TYPES.one;

  if (Array.isArray(activeItem)) {
    return isOnlyOneActiveItem ? activeItem.slice(0, 1) : activeItem;
  }

  return activeItem ? [activeItem] : [];
};
